module.exports = __webpack_public_path__ + "img/cupomDescontoFillLight.d964855a.svg";